import { useStore } from '@stores';
import { useEffect } from 'react';

export const useVehicle = (registrationNumber?: string | null) => {
  const { vehicleStore } = useStore();
  const { vehicle } = vehicleStore;

  useEffect(() => {
    registrationNumber && vehicleStore.getByRegistrationNumber(registrationNumber);

    return () => {
      vehicleStore.clearVehicle();
    };
  }, [vehicleStore, registrationNumber]);

  return vehicle;
};
